<unity-dropdown-clickable-control
  sortBy="name"
  textField="name"
  linkRoot="/form-type"
  [selectable]="$grouped()"
  [control]="$control()"
  [displayName]="$displayName()"
  [description]="$description()" />
